/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinishedDisposition
 */
export interface FinishedDisposition {
    /**
     * 
     */
    status: FinishedDispositionStatusEnum;
    /**
     * A finished code from episode_of_care_status_reasons
     */
    status_reason: string;
}


/**
 * @export
 */
export const FinishedDispositionStatusEnum = {
    Finished: 'finished',
} as const;
export type FinishedDispositionStatusEnum = typeof FinishedDispositionStatusEnum[keyof typeof FinishedDispositionStatusEnum];


/**
 * Check if a given object implements the FinishedDisposition interface.
 */
export function instanceOfFinishedDisposition(value: object): value is FinishedDisposition {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (value['status'] !== 'finished') return false;
    
    if (!('status_reason' in value) || value['status_reason'] === undefined) return false;
    return true;
}

export function FinishedDispositionFromJSON(json: any): FinishedDisposition {
    return FinishedDispositionFromJSONTyped(json, false);
}

export function FinishedDispositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishedDisposition {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'status_reason': json['status_reason'],
    };
}

export function FinishedDispositionToJSON(json: any): FinishedDisposition {
    return FinishedDispositionToJSONTyped(json, false);
}

export function FinishedDispositionToJSONTyped(value?: FinishedDisposition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'status_reason': value['status_reason'],
    };
}

